import { Address } from '@commenda/prisma';
import { IAddress, ILocationAddress } from '@commenda/types';
import { Country, State } from 'country-state-city';

export function getPrintableAddress(address: Address | IAddress) {
  if (!address || !Object.keys(address)?.length) return '';

  // Gives you a printable string from the Address Object
  // If else are based on valid Address assumptions
  let finalString = '';

  if (address.addressLine1) finalString += address.addressLine1;
  if (address.addressLine2) finalString += `, ${address.addressLine2}`;
  if (address.addressLine3) finalString += `, ${address.addressLine3}`;

  const city = address.city ? `, ${address.city}` : '';
  const state = State.getStateByCodeAndCountry(
    address.state,
    address.country
  )?.name;
  const stateString = state ? `, ${state}` : '';
  const postalCode = address.postalCode ? `, ${address.postalCode}` : '';
  const country =
    Country.getCountryByCode(address.country)?.name ?? address.country;
  const countryString = country ? ` ${country}` : '';

  finalString += `${city}${stateString}${countryString}${postalCode}`;

  return finalString.trim();
}

export function getPrintableBusinessLocation(address: ILocationAddress) {
  if (!address || !Object.keys(address)?.length) return '';

  const country =
    Country.getCountryByCode(address.country)?.name ?? address.country;

  const state = State.getStateByCodeAndCountry(
    address.state,
    address.country
  )?.name;

  return [
    address.addressLine1,
    address.addressLine2,
    address.addressLine3,
    address.city,
    state,
    country,
    address.postalCode,
  ]
    .filter(Boolean)
    .join(', ');
}
